// src/utils/axiosConfig.ts

import axios from 'axios';
import { getApiToken } from "../Features/LocalStorage/LocalStorageUtility";

// Release Url
const baseURL = 'https://paluel.admin.onlycontact.fr/api/';

//Debug Url
//  const baseURL = 'http://localhost:1337/api/';

// Créez une instance d'Axios
const axiosInstance = axios.create({
  baseURL: baseURL,
});

// Add Request interceptor
axiosInstance.interceptors.request.use(
  config => {
    //Setup API Token
    // we check if a user Token is saved in the local storage
     var token = getApiToken();
 
     // we check if the token is not empty
    if (!token || token.trim() === '') {
      // if not we check if a default App token is saved in the local storage
      token = localStorage.getItem('DefaultStrapiToken');
    }

    // if we have a token we add it to the request headers
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    else
    {
      console.error('No token found in local storage !');
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axiosInstance;